import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-card-payment-failure',
    templateUrl: './card-payment-failure.component.html',
    styleUrls: ['./card-payment-failure.component.scss'],
    standalone: false
})
export class CardPaymentFailureComponent implements OnInit {
  
  constructor(private router: Router) { }

  ngOnInit(): void {
    window.opener.location.href = '/mycart/payment/card-payment/failure'
    window.opener.focus()
    window.top.close();
  }

}
